import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';

import PrivateRoute from '../PrivateRoute';
import PublicRoute from '../PublicRoute';

const propTypes = {
  layout: PropTypes.func,
  component: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.func.isRequired,
  ]),
  exact: PropTypes.bool,
  path: PropTypes.string.isRequired,
  isPrivateRoute: PropTypes.bool,
};

const RenderRoute = ({
  layout: Layout,
  component: Component,
  exact,
  path,
  restricted,
  isPrivateRoute,
}) => {
  return path === '/' && !exact ? (
    <Route path={path} render={props => <Component {...props} />} />
  ) : isPrivateRoute ? (
    <PrivateRoute
      exact={exact}
      path={path}
      layout={Layout}
      restricted={restricted}
      component={Component}
    />
  ) : (
    <PublicRoute
      exact={exact}
      path={path}
      layout={Layout}
      restricted={restricted}
      component={Component}
    />
  );
};

RenderRoute.propTypes = propTypes;

export default RenderRoute;
